export const FAILED = 'FAILED';
export const SUCCESS = 'SUCCESS';
export const INFO = 'INFO';
